import { Fragment, useContext } from "react";
import MainImage1 from "../Assets/Img/MainImage01.jpg";
import AppContext from "./AppContext";
import { BannerText, HowItWorksText } from "./Texts.js";

const divStyle = {
	backgroundImage:
		"linear-gradient(to bottom, rgba(255,0,0,0), rgba(0,0,0,0.25), rgba(0, 0, 0, 0.85)), url(" +
		MainImage1 +
		")",
	height: "600px",
	backgroundPosition: "center",
	backgroundRepeat: "no-repeat",
	backgroundSize: "cover",
	position: "relative",
};

const heroText = {
	textAlign: "center",
	position: "absolute",
	top: "70%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	color: "white",
};

const Header = () => {
	const context = useContext(AppContext);
	const isDE = context.lang.get === "en";
	const steps = isDE ? HowItWorksText.steps_DE : HowItWorksText.steps_ENG;

	return (
		<Fragment>
			<header className="bg-primary text-white text-center" id="home">
				<div style={divStyle}>
					<div style={heroText}>
						<h1 className="mb-3" style={{ fontSize: "70px" }}>
							{isDE ? BannerText[0].title_DE : BannerText[0].title_ENG}
						</h1>
						<h4 className="mb-3">
							{isDE ? BannerText[0].subtitle_DE : BannerText[0].subtitle_ENG}
						</h4>
						{(isDE ? BannerText[0].text_DE : BannerText[0].text_ENG)
							.split("\n")
							.map((line, i) => (
								<h5 className="mb-3" key={i}>{line}</h5>
							))}
					</div>
				</div>
			</header>

			<section className="page-section" id="how-it-works" style={{ backgroundColor: "#f0f4f9" }}>
				<div className="container">
					<div className="text-center">
						<h2 className="page-section-heading text-secondary mb-0 d-inline-block">
							{isDE ? HowItWorksText.title_DE : HowItWorksText.title_ENG}
						</h2>
					</div>

					<div className="divider-custom">
						<div className="divider-custom-line"></div>
						<div className="divider-custom-icon">
							<i className="fas fa-star"></i>
						</div>
						<div className="divider-custom-line"></div>
					</div>

					<div className="row row-cols-1 row-cols-md-4 text-center g-0">
						{steps.map((step, i) => (
							<div className="col step-col" key={i}>
								<div className="step-circle">{i + 1}</div>
								<h6 className="fw-bold text-secondary mb-2">{step.title}</h6>
								<p className="text-muted small px-3 mb-0">{step.text}</p>
							</div>
						))}
					</div>
				</div>
			</section>
		</Fragment>
	);
};

export default Header;
